import '@styles/globals.scss'
import '@styles/index.css'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import { startTheme } from './helpers/theme'

startTheme()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

window.addEventListener('vite:preloadError', (event: Event) => {
  const customEvent = event as CustomEvent<{ message: string }>

  console.error('Vite preload error:', customEvent.detail.message, '\n', customEvent)
  window.location.reload()
})

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
